/* eslint-disable operator-linebreak */
import React, { FunctionComponent, useState, useEffect } from 'react';
import languageStyle from './styles/language.scss';
import logo from '../../assets/images/rtspro-logo-blue.svg';
import checkmark from '../../assets/images/check.png';
import { Button } from 'shamrock-clover-ui';
import { useTranslation } from 'react-i18next';
import { setHasUserSetLanguage, SupportedLanguages, SupportedLanguageDisplay } from '../../i18n';
import LanguageSelectionSpinner from '../core/LanguageSelectionSpinner';

interface LanguageButtonProps {
  displayName: string;
  languageKey: SupportedLanguages;
  selectedLanguage: SupportedLanguages;
  setSelectedLanguage: React.Dispatch<React.SetStateAction<SupportedLanguages>>;
}

const LanguageButton: FunctionComponent<LanguageButtonProps> = ({
  displayName,
  languageKey,
  selectedLanguage,
  setSelectedLanguage,
}) => {
  const { i18n } = useTranslation();

  return (
    <div
      className={languageStyle.lang_selecter}
      onClick={() => {
        setSelectedLanguage(languageKey);
        i18n.changeLanguage(languageKey);
      }}
    >
      {displayName}
      {selectedLanguage == languageKey ? <img src={checkmark} className={languageStyle.language_checked}></img> : null}
    </div>
  );
};

const Language: FunctionComponent<{setRerender: React.Dispatch<React.SetStateAction<number>>}> = ({
  setRerender,
}) => {
  const { i18n } = useTranslation();

  const [languageSelected, setSelectedLanguage] = useState<SupportedLanguages>(i18n.language as SupportedLanguages);
  const [showLanguageLoader, setShowLanguageLoader] = useState(false);

  const { t } = useTranslation();

  const handleRedirectToLanding = () => {
    setShowLanguageLoader(true);
  };

  useEffect(() => {
    if (showLanguageLoader) {
      const timerRef = setTimeout(() => {
        setShowLanguageLoader(false);
        setHasUserSetLanguage('true');
        setRerender(1);
      }, 1000);

      return () => clearTimeout(timerRef);
    }
  }, [showLanguageLoader]);

  const languageChangeText = SupportedLanguageDisplay.find((x) => x.languageKey === languageSelected);

  return (
    <>
      {showLanguageLoader && <LanguageSelectionSpinner text={languageChangeText.changeText} />}
      <div className={languageStyle.container}>
        <div className={languageStyle.languageWindow}>
          <div className={languageStyle.rtsProLogo}>
            <img src={logo} alt="rtspro_blue_logo" />
          </div>
          <div className={languageStyle.welcome}>
            <div className={languageStyle.welcomeInner}>
              <h2>{t('get_started')}</h2>
              <p>{t('choose_lng')}</p>
              <div className={languageStyle.selection_container}>
                {SupportedLanguageDisplay.map((x, i, list) => {
                  const isLast = list.length === i + 1;

                  return (
                    <>
                      <LanguageButton
                        displayName={x.displayName}
                        languageKey={x.languageKey}
                        selectedLanguage={languageSelected}
                        setSelectedLanguage={setSelectedLanguage}
                      />
                      {!isLast && <div className={languageStyle.lng_divider} />}
                    </>
                  );
                })}
              </div>
            </div>
          </div>
          <div className={languageStyle.btn_container}>
            <Button onClick={handleRedirectToLanding} width="102px" height="40px" data-testid="create-account-button">
              <span className={languageStyle.buttonText}>{t('continue')}</span>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Language;
